<template>
    <div>
        <div class="white" style="box-shadow: 0 0 5px rgba(0,0,0,.15); background: #fff; line-height: 1.2; margin: 10px 0 20px 0; padding: 0; overflow: hidden; border-radius: 10px; border: 0px solid #2979ff!important; ">
            <div style="display: block; padding: 15px 20px 0 20px; font-size: 16px; text-transform: uppercase; margin: 0;"
                class="white"
            >
                <small style="text-transform: none;" class="blue--text text--darken-3">Special settings</small>
                <div style="display: flex; position: relative;">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiAlertDecagramOutline</mdi>
                    <select style="width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" name="release" id="release"  @change="changeRelease" v-once>
                        <option :selected="release === 'public'" value="public">Public stable version</option>
                        <option :selected="release === 'test'" value="test">Latest test version</option>
                    </select>
                    <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                </div>

                <v-divider style="margin: 0 0;" />



                <div style="display: flex; position: relative;">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiHistory</mdi>
                    <select style="width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" @change="changeTrialDays" v-once>
                        <option value="">First open: auto</option>
                        <option value="0">First open: 0 days ago</option>
                        <option value="1">First open: 1 days ago</option>
                        <option value="2">First open: 2 days ago</option>
                        <option value="3">First open: 3 days ago</option>
                        <option value="4">First open: 4 days ago</option>
                    </select>
                    <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                </div>

                <v-divider style="margin: 0 0;" />

                <div style="display: flex; position: relative;">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiCreditCardOutline</mdi>
                    <select style="width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" @change="toggleSubscriptions">
                        <option value="">Toggle subscriptions</option>
                        <template v-for="subscription in subscriptions">
                            <option :value="subscription.sku">
                                <span v-text="subscription.subscribed ? 'Revoke - ' : 'Enable - '" />{{ subscription.title }}
                            </option>
                        </template>
                    </select>
                    <v-icon style="background: #fff; pointer-events: none; position: absolute; right: 0px; top: 14px; font-size: 28px;">arrow_drop_down</v-icon>
                </div>

                <v-divider style="margin: 0 0;" />

                <div style="display: flex; position: relative; justify-content: center;">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiCellphone</mdi>
                    <div style="text-transform: none; width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" v-once>
                        {{ deviceId }}
                    </div>
                </div>

                <v-divider style="margin: 0 0;" />

                <div style="display: flex; position: relative; justify-content: center;" @click="clearStorage">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiTrashCanOutline</mdi>
                    <div style="text-transform: none; width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" v-once>
                        Clear data
                    </div>
                </div>

                <v-divider style="margin: 0 0;" />

                <div style="display: flex; position: relative; justify-content: center;" @click="$bus.$emit('openAppDialog','review')">
                    <mdi class="grey--text text--darken-2 text--accent-3" style="margin: 15px 18px 0 2px;">mdiStarOutline</mdi>
                    <div style="text-transform: none; width: Calc(100% - 30px); color: #000; padding-right: 20px; font-size: 16px; padding: 0; line-height: 54px;" v-once>
                        Open review dialog
                    </div>
                </div>

                

            </div>
        </div>

    </div>
</template>
<script>
export default {


    data: () => {
        return ({
            release: location.hostname.includes("test.app.") ? 'test' : 'public',
            isDev: localStorage.getItem('isDevMode') === "true",
            deviceId: localStorage.getItem('deviceId') || 'Unknown device ID',
            subscriptions: [],
        });
    },

    created() {
        this.getSubscriptions();
        window.Tracker.logEvent({
            event_name: "show",
            event_category: "debug",
        });
    },

    methods: {
        changeRelease(e) {
            this.release = e.target.value;
            if (this.release === 'test') {
                window.location.replace('https://test.app.denticalc.com/index.html?packageName=' + window.packageName);
            } else {
                window.location.replace('https://public.app.denticalc.com/index.html?packageName=' + window.packageName);
            }
        },
        clearStorage() {
            localStorage.clear();
            localStorage.setItem('isDevMode', true);
            window.location.reload();
            window.Tracker.logEvent({
                event_name: "clear",
                event_category: "debug",
            });
        },
        changeTrialDays(e) {
            const v = e.target.value;
            if (v === '') return;

            let date = new Date().getTime();
            date -= 24*60*60*1000*v;
            this.setFirstRun(date);
            if (v>=3) this.$store.state.isPro = false;
            else this.$store.state.isPro = true;
            window.Tracker.logEvent({
                event_name: "changeTrialDays",
                event_category: "debug",
            });
        },
        setFirstRun(date) {
            localStorage.setItem('firstRunTS', date);
            localStorage.setItem('firstRunTSFS', date);
        },
        toggleSubscriptions(e) {
            window.Tracker.logEvent({
                event_name: "toggleSubscriptions",
                event_category: "debug",
            });
            const v = e.target.value;
            if (v === '') return;

            IAP.products[v].subscribed = !IAP.hasAccess(v);

            this.$nextTick(() => {
                this.$forceUpdate();
                this.getSubscriptions();
                e.target.value = "";
            });
        },
        getSubscriptions() {
            const subscriptions = [
                {
                    sku: 'four_in_one_monthly_sku',
                    title: 'Old PREMIUM',
                    subscribed: window.IAP.hasAccess('four_in_one_monthly_sku'),
                },
                {
                    sku: 'premium_access_monthly_sku_2021',
                    title: 'New PREMIUM',
                    subscribed: window.IAP.hasAccess('premium_access_monthly_sku_2021'),
                },
                {
                    sku: 'cloud_save_and_email_send_monthly_sku',
                    title: 'Email/save',
                    subscribed: window.IAP.hasAccess('cloud_save_and_email_send_monthly_sku'),
                }
            ];

            this.subscriptions = subscriptions;
        }
    }
}
</script>
